import React, { useEffect } from 'react'
import Layout from '../components/layout'
import { useTranslation } from 'react-i18next'
import MainAssets from '../sections/MainAssets'
import Spacer from '../uielements/Spacer'
import EduLevels from '../sections/EduLevels'
import Registrations from '../sections/Registrations'
import Numbers from '../sections/Numbers'
import {  greekLanguage } from '../lib/constants'
import PageHeader from '../components/PageHeader'
import OurValues from '../sections/OurValues'

export const Head = () => {
    const { t, i18n } = useTranslation()

    return (
        <>
            <html lang={i18n.language} />
            <title>{t('seo.titles.home')}</title>
            <meta name="description" content={t('seo.metaDesc.home')} />
        </>
    )
}

const IndexPage = () => {
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language
    let language = currentLang

    useEffect(() => {
        const lang = new URLSearchParams(window.location.search).get('lang') ?? greekLanguage
        language = currentLang !== lang ? i18n.changeLanguage(lang) : currentLang
    }, [])

    return (
        <Layout>
            <PageHeader title={t('titles.welcome')} featVideoId={'7x7MiFXakQE'} />
            {/*<Wrapper>some banner goes here</Wrapper>*/}
            <OurValues />
            <MainAssets />
            <Spacer top="10" />
            <EduLevels />
            <Spacer top="4" />
            <Registrations />
            <Spacer top="10" />
            {/*<Numbers />*/}
            {/*<Spacer top="10" />*/}
        </Layout>
    )
}

export default IndexPage
